import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['image', 'placeholder']

  connect () {
    this.loadImage()
  }

  loadImage () {
    const img = this.imageTarget
    const placeholder = this.placeholderTarget

    // eslint-disable-next-line no-undef
    const preloadedImage = new Image()
    preloadedImage.src = img.dataset.src

    preloadedImage.onload = () => {
      img.src = preloadedImage.src
      img.classList.remove('opacity-0')
      placeholder.remove()
    }
  }
}
